import type { WalletAdapter } from '../../types';

import { Icon } from './icon';
import { getWcConnector } from './utils';

export const wcId = 'walletConnect';
export const wcName = 'WalletConnect';

type Params = {
  walletconnectProjectId: string;
};

export const WalletConnect: WalletAdapter = ({ walletconnectProjectId }: Params) => ({
  walletName: wcName,
  walletId: wcId,
  type: getWcConnector.type,
  Icon,
  detector: () => true,
  getConnector: () => getWcConnector({ projectId: walletconnectProjectId }),
});
